<template>
  <div class="page-home" :class="{ noscroll: activePopup || searchShow }">
    <!-- 渐变背景 -->
    <div class="top-bg"></div>
    <!-- app版本信息，兼容抖音小程序-->
    <header
      class="app-info"
      :style="'height:' + (from != 'tt-oil' ? '1.18rem' : '0.2rem')"
    >
      <div v-if="from != 'tt-oil'" class="left">
        <img class="app-logo" :src="app_icon" />
        <div class="app-name">{{ app_name }}</div>
      </div>
      <div v-if="from != 'tt-oil'" class="right" @click="toFeedback">
        <img
          class="feedback-icon"
          src="@/assets/home/black-feedback-icon.png"
        />
        <div class="feedback-text">反馈</div>
      </div>
    </header>
    <section v-show="loadData && brandList.length != 0">
      <!-- AI识车 & 搜索栏 -->
      <div class="ai-content">
        <!-- AI识车banner -->
        <div class="ai-class">
          <img
            class="ai-class-img"
            src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/ai-banner.png"
            alt=""
            @click="vehicle_dialog = true"
          />
          <img
            class="small-icon"
            src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/ai-gif-dist.gif"
          />
        </div>

        <!-- 搜索栏 -->
        <div class="search">
          <div class="search-box flex" @click="searchCar">
            <img
              class="search-icon"
              src="https://select-oil-oss.vchangyi.com/wxapp/icon-search.png"
              alt=""
            />
            <span class="color-gray9">请输入车辆品牌或vin码</span>
          </div>
          <!-- 微信环境 -->
          <div class="feedback" v-if="iswx == 1" @click="photographFun()">
            <img
              src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/home-black-scan-icon.png"
            />
            <span>VIN码解析</span>
          </div>
          <!-- 非微信环境 -->
          <div
            v-if="iswx == 0"
            class="feedback m-r-10"
            style="pointer-events: auto"
            v-upfiled="config"
          >
            <img
              src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/home-black-scan-icon.png"
            />
            <span>VIN码解析</span>
          </div>
          <div
            class="image-box"
            ref="h5_upload"
            v-show="false"
            hidden="true"
            style="pointer-events: auto; cursor: pointer"
            v-upfiled="config"
          >
            <img src="@/assets/home/yellow-camera-icon.png" alt="" />
            <div class="desc">识图</div>
          </div>
          <!-- <div class="feedback m-r-10" @click="feedback()">
            <img
              src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/home-black-feedback-icon.png"
            />
            <span>反馈</span>
          </div> -->
        </div>
      </div>
      <!-- 主页面部分 -->
      <div
        class="main"
        v-bind:class="{
          filter: searchShow,
          filterBlur: activePopup,
          noscroll: activePopup != '',
        }"
      >
        <div class="content">
          <!-- 热门品牌 -->
          <div class="hot" v-if="hotBrandList.length > 0">
            <div class="font-27 color-gray3 title">
              <span>热门品牌</span>
            </div>
            <div class="brand flex">
              <div class="column flex">
                <div
                  class="hot-brand"
                  v-for="(item, index) in hotBrandList"
                  v-if="index < 5"
                  :key="index"
                >
                  <div @click="choose(1, item)">
                    <div class="brand-logo">
                      <img v-bind:src="item.logo_url" alt />
                    </div>
                    <div class="brand-name" v-text="item.name"></div>
                  </div>
                </div>
              </div>
              <div class="column flex">
                <div
                  class="hot-brand"
                  v-for="(item, index) in hotBrandList"
                  v-if="index > 4"
                  :key="index"
                >
                  <div @click="choose(1, item)">
                    <div class="brand-logo">
                      <img v-bind:src="item.logo_url" alt />
                    </div>
                    <div
                      class="brand-name font-11 color-gray5"
                      v-text="item.name"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 全量品牌 -->
          <div class="brand-list">
            <div
              class="brand-item"
              :id="'anchor-' + id"
              v-for="(item, id) in brandList"
              :key="id"
            >
              <div class="item-title">
                <span v-text="item.letter"></span>
              </div>
              <div
                class="item-detail flex"
                v-for="(type, index) in item.brands"
                :key="index"
              >
                <div class="left">
                  <img
                    :src="
                      type.logo_url
                        ? type.logo_url
                        : 'https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/default_car_logo.png'
                    "
                  />
                  <img
                    v-if="type.is_new_energy == 1"
                    src="https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/active_car_name.png"
                    class="new-energy-tag"
                  />
                </div>
                <div
                  :class="{
                    right: true,
                    'bottom-border': index !== item.brands.length - 1,
                  }"
                >
                  <div class="name">
                    <span v-text="type.name" @click="choose(1, type)"></span>
                  </div>
                  <img
                    class="new-right-tag"
                    v-if="type.is_new_energy == 1"
                    src="https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/new_energy_car.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧索引字母 -->
      <div
        class="nav-bar"
        v-show="!activePopup"
        v-bind:class="{ filter: searchShow, filterBlur: activePopup }"
      >
        <div class="nav-item" v-for="(item, index) in brandList" :key="index">
          <div class="bubble font-20" v-text="item.letter"></div>
          <div class="indexes font-9" @click="goAnchor(index)">
            <span v-text="item.letter"></span>
          </div>
        </div>
      </div>
    </section>
    <!-- 缺省展示 -->
    <LayoutEmpty v-if="loadData && brandList.length == 0"></LayoutEmpty>
    <!-- 搜索vin码、上传vin码展示的车型列表 -->
    <popup-select
      :accessMenus="accessMenus"
      :defaultList="defaultList"
      :v-model="vehiclePopup"
      :initParams="initParams"
      @close="closeVehiclePopup"
    />
    <!-- 悬浮窗 -->
    <fab-button
      v-if="uuid_ready"
      :padding_bottom="from == 'curing-workbench-web-wx-app' ? 1.8 : 0"
    ></fab-button>
    <!-- （点击品牌）厂家-车系弹出层 -->
    <series-popup
      :is_new_energy="current_is_new_energy"
      :initParams="initParams"
      :visible="seriesVisible"
      @close="seriesVisible = false"
    ></series-popup>
    <!-- 跳过查询浮窗（从精养助手小程序 web-view 打开） -->
    <div
      v-if="from == 'curing-workbench-web-wx-app'"
      class="jump-over-float"
      :class="{ disabled: guide_show == '1' }"
    >
      <img
        v-if="guide_show != '1'"
        class="jump-over-float-img"
        src="@/assets/home/icon-jump-over.png"
        alt="跳过查询"
        @click="jump"
      />
      <img
        v-else
        class="jump-over-float-img"
        src="@/assets/home/icon-jump-over-disabled.png"
        alt="跳过查询"
      />
    </div>
    <!-- AI识车拍照提示弹窗 -->
    <div class="dialog-mask overlay-fade-in" v-if="vehicle_dialog">
      <div class="vehicle_example overlay-fade-in">
        <div class="head-box">
          车辆拍照示意
          <img
            class="close_vehicle_modal"
            src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/close_vehicle_modal.png"
            @click="vehicle_dialog = false"
          />
        </div>
        <img
          class="vehicle_example_img"
          src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/vehicle_example1.png"
        />
        <img
          class="vehicle_example_img"
          src="https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/vehicle_example2.png"
        />
        <div class="desc">
          拍摄车辆进行AI识别时，建议站于车物正前方、斜前方、斜后方或后方，将车辆完整露出。拍摄时，请保证画面画质清晰，如需识别车辆车牌，请保证车牌无遮挡。
        </div>
        <!-- 微信环境，调用微信上传 -->
        <div class="btn" v-if="iswx == 1" @click="photographAndIdentify">
          去拍摄
        </div>
        <!-- H5环境，使用原生上传 -->
        <van-uploader
          v-else
          :after-read="afterRead"
          capture="camera"
          accept="image/*"
          ref="h5Upload"
        >
          <div class="btn">去拍摄</div>
        </van-uploader>
      </div>
    </div>
    <!-- 操作指引按钮 -->
    <div class="guide-exit" v-if="guide_show == '1'" @click="exitGuide">
      <img
        class="icon-guide-exit"
        src="@/assets/guide/guide-exit-black.png"
        alt="退出指引"
      />
    </div>
  </div>
</template>
<script>
import FabButton from "@/components/FabButton.vue";
import api from "@/apis/maintenance-api.js";
import wx from "weixin-js-sdk";
import LayoutEmpty from "@/components/Layouts/LayoutEmpty";
import $ from "jquery";
import PopupSelect from "@/components/PopupSelect.vue";
import MaintenanceApi from "@/apis/maintenance-api.js";
import { wxShare } from "@/plugins/WxConfig.js";
import { channelScanRecord } from "@/utils/data-burial";
import validToken from "@/mixins/valid-token.js";
import SeriesPopup from "@/components/SeriesPopup.vue";
import { Uploader } from "vant";
import { default_menus } from "./constants/default-menus";
import { compressImg } from "@/utils/tools.js";
import tt from "tt";
export default {
  name: "home",
  // components: { LayoutEmpty, PopupSelect, FabButton, SeriesPopup },
  components: {
    LayoutEmpty,
    PopupSelect,
    SeriesPopup,
    FabButton,
    VanUploader: Uploader,
  },
  mixins: [validToken],
  data() {
    return {
      defaultList: {
        singleTitle: {
          title: "",
        },
        list: [],
      },
      seriesVisible: false,
      initParams: {},
      accessMenus: [],
      vehiclePopup: false,
      activePopup: "", //当前激活的弹出层（取值见template）
      searchShow: false,
      searchDefault: false,
      brandList: [], //首页全量车辆品牌列表
      searchName: "",
      hotBrandList: [], //热门车辆品牌列表
      currentChoosedNameList: [], //包含车系的车型列表（一级选择列表）
      currentChoosedDisplacementList: [], //  (排量 手/自动 化油器) 二级筛选列表
      currentChoosedYearList: [], //车辆年份 (三级筛选列表)
      vinCarList: [], // vin识别之后的车型数据
      searchDataList: [], //搜索结果列表
      iswx: this.browser.wx, // 是否是微信环境，
      config: {
        url: `${window.VUE_APP_API_ROOT}oil/h5/get_vehicle_id_new`,
        size: "10",
        fileType: ["jpg", "png", "jpeg", "gif", "bmp"],
        multiple: false,
        atMediatype: "99",
        callback: this.uploadCall,
        // beforeFun: this.fetchValidToken,
        params: { parts_type: 1 },
        token: "",
        isIos: true,
        iosCallback: this.checkToken,
      },
      loadData: false,
      isScan: false, // 是否是vin识别
      carInfo: null, // 车辆的所有信息
      app_icon: "",
      app_name: "",
      uuid_ready: false,
      from: "", // 来源
      guide_show: "2", // 是否开启操作指引 '1': 开启 '2': 关闭
      vehicle_dialog: false, // 车辆拍照示意弹窗
      default_menus: default_menus,
      current_is_new_energy: 2,
    };
  },
  created() {
    let u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  },
  async mounted() {
    if (!this.$route.query.id) {
      this.$route.query.id = window.sessionStorage.getItem("OILVERSION");
    }
    this.from = this.$route.query.from || "";
    this.guide_show = this.$route.query.guide_show || "2";
    window.sessionStorage.setItem("FROM", this.from);
    window.sessionStorage.setItem("GUIDE_SHOW", this.guide_show);
    this.fetchBrandList(); //获取车辆品牌列表和热门车辆品牌列表
    window.sessionStorage.setItem("OILVERSION", this.$route.query.id); // 缓存版本
    this.setStatistics();
    this.initData();
    this.scroll();
    wxShare();
    console.log("uuid", localStorage.getItem("OILUSER"));

    // TODO：优化
    // if (!sessionStorage.getItem("valid_menus")) {
    //   await this.fetchValidMenus();
    // }
  },
  methods: {
    /**
     * 初始化数据：版本信息、分享配置
     */
    async initData() {
      if (
        !window.sessionStorage.getItem("OILSHARE") &&
        (this.$route.query.scheme_id || this.$route.query.id)
      ) {
        const res = await MaintenanceApi.getShareApi({
          scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        });
        if (res.code === 0) {
          window.sessionStorage.setItem("OILSHARE", JSON.stringify(res.data));
          this.app_icon = res.data.h5_logo;
          this.app_name = res.data.name;
        } else {
          console.error("数据统计失败", res.message);
        }
      } else if (window.sessionStorage.getItem("OILSHARE")) {
        const obj = JSON.parse(window.sessionStorage.getItem("OILSHARE"));
        this.app_icon = obj.h5_logo;
        this.app_name = obj.name;
      }
    },
    /**
     * 渠道二维码扫码记录(埋点)
     */
    async dataBurial() {
      if (!this.$route.query.c) return;
      const uuid = window.localStorage.getItem("OILUSER")
        ? window.localStorage.getItem("OILUSER")
        : "";
      const params = {
        scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        channel_id: this.$route.query.c ? Number(this.$route.query.c) : "",
        customer_id: uuid,
      };
      await channelScanRecord.apply(this, [params]);
    },
    /**
     * 获取开放菜单
     */
    async fetchValidMenus() {
      try {
        const res = await api.getValidMenusApi({
          scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        });
        if (res.code === 0) {
          console.log("======", res.data);
          sessionStorage.setItem("valid_menus", JSON.stringify(res.data));
        } else {
          this.$toast.show({
            showTime: 3,
            message: "获取开放菜单失败",
            style: "error",
          });
        }
      } catch (error) {
        error && console.log("获取开放菜单失败！");
      }
    },
    /**
     * H5上传拍照检查是否有token
     */
    async checkToken(e) {
      await this.fetchValidToken((token) => {
        this.$set(this.config, "params", { parts_type: 1, token });
        this.config.token = token;
        console.log("tokentokentoken", token);
        e && this.$refs.h5_upload.iosUpload(e, token);
      });
    },
    /**
     * 访问次数统计
     */
    setStatistics() {
      let user = window.localStorage.getItem("OILUSER");
      api
        .visitRecord({
          uuid: user,
          scheme_id: this.$route.query.id,
        })
        .then(async (res) => {
          if (res.code == 0) {
            window.localStorage.setItem("OILUSER", res.data.uuid);
            this.uuid_ready = true;
            await this.dataBurial();
            console.log("数据统计成功");
          } else {
            console.error("数据统计失败", res.message);
          }
        });
    },
    /**
     * 关闭车型弹出层
     */
    closeVehiclePopup() {
      this.vehiclePopup = false;
      this.defaultList = {
        internal_from: "", //内部来源 标识vin码字符串搜索（text_vin）还是vin码图片识别（photo_vin），用于埋点区分来源
        singleTitle: {
          title: "",
        },
        list: [],
      };
    },
    /**
     * 获取车辆品牌列表及开放菜单
     */
    fetchBrandList() {
      this.loadData = false;
      this.$loading.show("加载中...");
      api
        .carBrandList({
          scheme_id: this.$route.query.id ? this.$route.query.id : "",
        })
        .then((res) => {
          if (res.code == 0) {
            let tempArr = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
            for (let i = 0; i < res.data.hot.length; i++) {
              tempArr[i] = res.data.hot[i];
            }
            this.hotBrandList = tempArr;
            this.brandList = res.data.all;
            // this.accessMenus = res.data.menus.map((i) => i.type);
            // --
            const valid_menus_types = res.data.menus //开放菜单type数组
              .filter((i) => i.is_show === 1)
              .map((i) => i.type);
            const temp_valid_menus = this.default_menus.filter((i) =>
              valid_menus_types.includes(i.type)
            ); //临时开放菜单项数组
            sessionStorage.setItem(
              "valid_menus",
              JSON.stringify(temp_valid_menus)
            );
            this.$loading.hide();
            this.loadData = true;
          } else {
            this.$toast.show({
              showTime: 3,
              message: res.message,
              style: "error",
            });
          }
        });
    },
    /**
     * 拍照识别车型
     */
    photographAndIdentify() {
      let self = this;
      wx.chooseImage({
        count: 1,
        sizeType: ["compressed"],
        sourceType: ["camera"],
        success: function (res) {
          console.log(233, res);
          let id = res.localIds[0];
          // self.$loading.show("识别中...");
          wx.getLocalImgData({
            localId: id,
            success: function (res) {
              let localData = res.localData;
              if (localData.indexOf("data:image") != 0) {
                //判断是否有这样的头部
                localData = "data:image/jpeg;base64," + localData;
              }
              localData = localData
                .replace(/\r|\n/g, "")
                .replace("data:image/jgp", "data:image/jpeg");
              const file = self.base64ToFile(localData);
              console.log(233333, file);
              self.afterRead({ file: file, content: localData });
            },
          });
        },
        fail(err) {
          console.log("err", err);
        },
      });
    },
    /**
     * 打开搜索界面
     */
    searchCar() {
      this.$router.push({
        name: "search-page",
        query: {
          scheme_id: this.$route.query.id,
        },
      });
      // this.searchShow = !this.searchShow;
      // this.$nextTick(() => {
      //   this.$refs.inputEle.focus();
      //   this.searchName = "";
      //   this.searchDataList = [];
      //   this.levelId = "";
      // });
    },
    /**
     * vin码车型列表
     */
    fetchVinModelList() {
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      api
        .getModelDetail({
          vehicle_vin: this.searchName,
          parts_type: 1,
          token: this.token,
          scheme_id,
        })
        .then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.vinCarList = res.data.vehicle_list;

            this.vinCarList.forEach(
              (i) =>
                (i.text = `${i.brand_name} ${i.model_alias} ${
                  i.release_year
                }款${i.sales_name} ${i.engine_model ? i.engine_model : ""}`)
            );
            this.defaultList.internal_from = "text_vin";
            this.defaultList.list = this.vinCarList;
            this.defaultList.singleTitle = {
              title: "请选择车型",
              pic: res.data.vehicle_list[0].brand_logo_url,
            };
            this.vehiclePopup = true;
          } else {
            this.$toast.show({
              showTime: 2,
              message: res.message,
              style: "error",
            });
          }
        });
    },
    /**
     * 点击搜索vin码或品牌名称
     */
    async search() {
      if (!this.searchName) {
        return;
      }
      let reg = new RegExp(/[a-z0-9A-Z]{17}/);
      if (reg.test(this.searchName)) {
        await this.fetchValidToken(this.fetchVinModelList);
      } else {
        this.$loading.show("加载中...");
        api.searchData({ name: this.searchName }).then((res) => {
          if (res.code == 0) {
            this.searchDataList = res.data;
            if (this.searchDataList.length == 0) {
              this.$toast.show({
                showTime: 2,
                message: "暂无车辆信息",
                style: "error",
              });
            }
          } else {
            this.$toast.show({
              showTime: 2,
              message: res.message,
              style: "error",
            });
          }
          this.$loading.hide();
        });
      }
    },
    // 返回
    back(index) {
      if (index == 1) {
        this.activePopup = "changBrand";
      }
      if (index == 2) {
        this.activePopup = "changeType";
      }
    },
    /**
     * 点击菜单
     * @param {number} index
     * @param {*} current
     */
    choose(index, current) {
      const { name, logo_url, is_new_energy } = current;
      // 0 点击车辆品牌
      if (index == 1) {
        this.current_is_new_energy = is_new_energy;
        this.initParams = { brand_name: name, logo: logo_url, is_new_energy };
        this.seriesVisible = true;
        return;
      }
    },

    cancelChoose() {
      $(".nav-item").removeClass("nav-item-active");
      this.activePopup = "";
      this.isScan = false;
    },

    // 右侧字母滑动
    goAnchor(index) {
      let anchor = this.$el.querySelector("#anchor-" + index);
      $(document).scrollTop(anchor.offsetTop - 46);
      $(".bubble").hide();
      $(".nav-item").removeClass("nav-item-active");
      $(".nav-item").eq(index).addClass("nav-item-active");
      $(".bubble").eq(index).show();
      setTimeout(function () {
        $(".bubble").hide();
        //  $('.nav-item').removeClass('nav-item-active')
      }, 500);
      if (navigator.vibrate) {
        // 支持
        console.log("支持设备震动！");
        navigator.vibrate(200);
      }
    },
    /**
     * 点击反馈图标
     */
    feedback() {
      this.$router.push({
        path: "/maintenance-feedback",
      });
    },

    scroll() {
      const that = this;
      $(document).scroll(function () {
        for (let i in that.brandList) {
          if ($(".brand-item").eq(i).offset()) {
            if (
              $(".brand-item").eq(i).offset().top - $(document).scrollTop() <
              47
            ) {
              if ($(".nav-item").eq(i).hasClass("nav-item-active") && i != 0) {
                return;
              }
              $(".nav-item").removeClass("nav-item-active");
              $(".nav-item").eq(i).addClass("nav-item-active");
            }
          }
        }
      });
    },
    /**
     * 上传vin码成功回调函数
     * @param {*} res
     */
    uploadCall(res) {
      let loading = this.$loading;
      loading.hide();
      if (res.code == 0) {
        this.vinCarList = res.data.vehicle_list;
        this.vinCarList.forEach(
          (i) =>
            (i.text = `${i.brand_name} ${i.model_alias} ${i.release_year}款${
              i.sales_name
            } ${i.engine_model ? i.engine_model : ""}`)
        );
        this.defaultList.internal_from = "photo_vin";
        this.defaultList.list = this.vinCarList;
        this.defaultList.singleTitle = {
          title: "请选择车型",
          pic: res.data.vehicle_list[0].brand_logo_url,
        };
        this.vehiclePopup = true;
      } else {
        this.$toast.show({
          showTime: 3,
          message: res.message,
          style: "error",
        });
      }
    },
    async photographFun() {
      await this.fetchValidToken(this.photograph);
    },
    /**
     * 微信选择图片
     */
    photograph() {
      let self = this;
      if (this.iswx == 1) {
        wx.chooseImage({
          count: 1,
          sizeType: ["compressed"],
          sourceType: ["album", "camera"],
          success: function (res) {
            let id = res.localIds[0];
            self.$loading.show("识别中...");
            wx.getLocalImgData({
              localId: id,
              success: function (res) {
                // IOS & 安卓兼容逻辑
                let localData = res.localData;
                if (localData.indexOf("data:image") != 0) {
                  //判断是否有这样的头部
                  localData = "data:image/jpeg;base64," + localData;
                }
                localData = localData
                  .replace(/\r|\n/g, "")
                  .replace("data:image/jgp", "data:image/jpeg");
                self.dataURLtoFile(localData);
              },
            });
          },
          fail(err) {
            console.log("err", err);
          },
        });
      }

      // 兼容都应，暂时用不到，不用处理
      if (this.iswx == 2) {
        tt.miniProgram.chooseImage({
          count: 1,
          sizeType: ["compressed"],
          sourceType: ["album", "camera"], // 可选择性开放访问相册、相机
          success: () => {
            this.$toast.show({
              showTime: 3,
              message: "选择成功",
              style: "success",
            });
          },
          fail() {},
        });
      }
    },
    // 微信图片上传
    uploadVinImage(param) {
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      api
        .uploadVinApi({
          base_64: param,
          parts_type: 1,
          scheme_id,
          token: this.token,
        })
        .then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.vinCarList = res.data.vehicle_list;
            this.vinCarList.forEach(
              (i) =>
                (i.text = `${i.brand_name} ${i.model_alias} ${
                  i.release_year
                }款${i.sales_name} ${i.engine_model ? i.engine_model : ""}`)
            );
            this.defaultList.internal_from = "photo_vin";
            this.defaultList.list = this.vinCarList;
            this.defaultList.singleTitle = {
              title: "请选择车型",
              pic: res.data.vehicle_list[0].brand_logo_url,
            };
            this.vehiclePopup = true;
          } else {
            this.$toast.show({
              showTime: 3,
              message: res.message,
              style: "error",
            });
          }
        });
    },
    // 将base64转换成file
    dataURLtoFile(dataUrl) {
      try {
        let _this = this,
          bstr = null,
          n = null,
          u8arr = null;
        let mime = dataUrl.split(",")[0].match(/:(.*?);/)[1]; //mime类型 image/png
        if (dataUrl.indexOf(",") > 0) {
          //  ios兼容
          let arr = dataUrl.split(",");
          bstr = atob(arr[1]);
        } else {
          bstr = atob(dataUrl);
        }
        n = bstr.length;
        u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File(
          [u8arr],
          `select_oil_${new Date().getTime()}.${mime.split("/")[1]}`,
          { type: mime }
        );
        _this
          .lrz(file, {
            quality: 0.4,
          })
          .then((rst) => {
            let base = rst.base64.split("base64,");
            console.log("-4930", base);
            _this.uploadVinImage(base[1]);
          });
      } catch (err) {
        console.error("异常", err);
      }
    },
    base64ToFile(base64) {
      try {
        let bstr = null;
        let n = null;
        let u8arr = null;
        let mime = base64.split(",")[0].match(/:(.*?);/)[1]; //mime类型 image/png
        if (base64.indexOf(",") > 0) {
          //  ios兼容
          let arr = base64.split(",");
          bstr = atob(arr[1]);
        } else {
          bstr = atob(base64);
        }
        n = bstr.length;
        u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File(
          [u8arr],
          `select_oil_${new Date().getTime()}.${mime.split("/")[1]}`,
          { type: mime }
        );
        return file;
      } catch (err) {
        console.error("异常", err);
        return null;
      }
    },
    /**
     * 跳过查询（从精养助手小程序 web-view 打开时，跳过查询车型逻辑）
     */
    jump() {
      wx.miniProgram.postMessage({ data: { guide_show: this.guide_show } });
      wx.miniProgram.navigateBack();
    },
    /**
     * 退出操作指引
     */
    exitGuide() {
      this.guide_show = "2";
      window.sessionStorage.setItem("GUIDE_SHOW", this.guide_show);
    },
    /**
     * 跳转反馈页面
     */
    toFeedback() {
      this.$router.push({
        path: "/maintenance-feedback",
      });
    },
    /**
     * 识别图片 & 存储图片base64到本地
     * @param {*} file
     */
    async afterRead(file) {
      console.log(file);
      const res = await compressImg(file.file, 0.7);
      if (file.content) {
        res.content = file.content;
      }
      console.log(res);
      const formData = new FormData();
      formData.append("file", res.file);
      sessionStorage.removeItem("current_photo_base64");
      sessionStorage.setItem(
        "current_photo_base64",
        res.afterSrc || res.content
      );
      try {
        this.$loading.show("加载中...");
        const res = await api.identifyVehicleByPhotoApi(formData);
        if (res.code == 0) {
          this.$loading.hide();
          console.log("识别结果", res);
          this.$router.push({
            name: "engine-displacement",
            query: {
              ...res.data,
              internal_from: "ai_photo",
              scheme_id: this.$route.query.id,
            },
          });
        } else {
          this.$loading.hide();
          this.$router.push({
            name: "engine-displacement",
            query: {
              internal_from: "ai_photo",
              scheme_id: this.$route.query.id,
            },
          });
        }
      } catch (error) {
        this.$loading.hide();
        error && console.log("上传图片异常", error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../style/page/maintenance/home.less";
</style>
